@let productsKeyValue = sortedFilteredProducts();

<div class="container">
  <div class="content">
    <div class="content__hero hero">
      <div class="hero__background">
        @if (isVideoUrl(restaurant().hero || '')) {
          <video
            #heroVideo
            *skeleton="isRestaurantLoading(); width: '100%'; height: '400px'"
            class="hero__background_img"
            [src]="restaurant().hero || ''"
            [attr.playsinline]="'playsinline'"
            [attr.preload]="'auto'"
            [muted]="true"
            [loop]="true"
            [autoplay]="true"
          ></video>
        } @else {
          <img
            *skeleton="isRestaurantLoading(); width: '100%'; height: '400px'"
            [src]="restaurant().hero || ''"
            loading="lazy"
            class="hero__background_img"
            alt="background"
          />
        }
      </div>

      <div class="hero__logo">
        <img
          *skeleton="isRestaurantLoading(); width: '120px'; height: '120px'"
          [src]="restaurant().main_icon || ''"
          loading="lazy"
          alt="logo"
          class="hero__logo_img"
        />
      </div>
    </div>

    <div class="content__restaurant restaurant">
      <div class="restaurant__details">
        <h3 class="restaurant__details_name">
          <ng-container
            *skeleton="isRestaurantLoading(); width: '250px'; height: '40px'"
          >
            <span [innerHTML]="restaurant().name"></span>
          </ng-container>
        </h3>

        @if (restaurant().description) {
          <p class="restaurant__details_tagline">{{ restaurant().description }}</p>
        }

        <div class="restaurant__details_info restaurant-info">
          <ng-container
            *skeleton="isRestaurantLoading(); width: '280px'; height: '24px'"
          >
            <div class="restaurant-working-hours">
              <div
                class="restaurant-working-hours__current"
                [ngClass]="[
                  isRestaurantOpen() ? 'restaurant-opened' : 'restaurant-closed'
                ]"
              >
                <i class="icon icon-clock-outline"></i>
                <div class="restaurant-working-hours__current_label">
                  @if (isRestaurantOpen()) {
                    Open now
                  } @else if (isTodayHoliday()) {
                    Closed for {{ todayHolidayReason() || 'Holiday' }}
                  } @else {
                    Currently Closed
                  }
                </div>
              </div>

              <p>|</p>

              <div class="restaurant-working-hours__next">
                <div class="restaurant-working-hours__next_label">
                  @if (isRestaurantOpen()) {
                    Closes at {{ todayWorkingHours()?.close_time }}
                  } @else if (willOpenLaterToday()) {
                    Opens at {{ todayWorkingHours()?.start_time }}
                  } @else if (nextOpeningInfo()) {
                    Opens {{ nextOpeningInfo()?.day }} at {{ nextOpeningInfo()?.time | uppercase }}
                  }
                </div>
              </div>
            </div>

            @if (false) {
              <div class="restaurant-info__rating restaurant-rating">
                <div class="restaurant-rating__stars">
                  <i class="restaurant-rating__stars_icon icon icon-star"></i>
                </div>
                <!-- HIDDEN Waiting For Api -->
                <div class="restaurant-rating__label">
                  <span class="restaurant-rating__label_rate">{{ 4.5 }}</span>
                  <span class="restaurant-rating__label_count">
                    ({{ 678 }})
                  </span>
                </div>
              </div>
            }

            @if (restaurant().genre) {
              <div class="restaurant-info__county restaurant-country">
                <div class="restaurant-country__label" [innerHtml]="restaurant().genre"></div>
              </div>
            }
          </ng-container>
        </div>

        <div
          *skeleton="isRestaurantLoading(); width: '125px'; height: '40px'"
          class="restaurant__details_footer"
        >
          <app-button
            [style]="ButtonStyle.Contrast"
            (click)="openRestaurantDetailsModal()"
          >
            Learn More
          </app-button>
          @if (restaurant().phone) {
            <a [href]="'tel:' + restaurant().phone" class="unstyled-link">
              <app-button [style]="ButtonStyle.Transparent">
                <i class="icon-phone-outline"></i>
                Give us a call
              </app-button>
            </a>
          }
          @if (restaurant().email) {
            <a [href]="'mailto:' + restaurant().email" class="unstyled-link">
              <app-button [style]="ButtonStyle.Transparent">
                <i class="icon-mail-outline"></i>
                <p>Contact by email</p>
              </app-button>
            </a>
          }

<!--          @if (banners().length > 0) {-->
<!--            <app-button-->
<!--              [style]="ButtonStyle.Transparent"-->
<!--              (click)="openLinkInNewTab(banners()[0].link.url)"-->
<!--            >-->
<!--              <i class="icon-gift-card"></i>-->
<!--              <p>Buy a Gift Card</p>-->
<!--            </app-button>-->
<!--          }-->
        </div>
      </div>

      <ng-container
        *skeleton="isRestaurantLoading(); width: '320px'; height: '72px'"
      >
        <div class="restaurant__selection-container">
          @if (isRestaurantOpen()) {
            <div class="restaurant__get-way">
              <div class="restaurant__get-way_switcher">
                <app-option-switcher
                  [options]="SHIPPING_OPTIONS()"
                  [(ngModel)]="shippingMethod"
                  (change)="onShippingMethodChange($event)"
                />
              </div>

              @if (shippingMethod() === ShippingMethod.Pickup) {
                <div class="restaurant__get-way_map">
                  <google-map
                    height="199px"
                    width="100%"
                    [options]="GOOGLE_MAP_OPTIONS"
                    (mapInitialized)="onMapInitialized($event)"
                  />
                </div>

                <span class="restaurant__get-way_address">
                  {{ restaurant().address }}
                </span>
              }
            </div>
          } @else {
            <app-button
              class="restaurant__schedule-button"
              [size]="ButtonSize.Large"
              [style]="ButtonStyle.Primary"
              (click)="openScheduleModal()"
            >
              <i class="icon icon-clock-outline"></i>
              Schedule your order for Delivery or Pickup
            </app-button>
          }

          <div class="restaurant__search">
            <app-search
              [placeholder]="'Search ' + this.restaurantName()"
              [(ngModel)]="searchText"
            />
          </div>
        </div>
      </ng-container>
    </div>

    @if (selectedScheduleDescription(); as selectedScheduleDescription) {
      <div class="restaurant__closing-warning">
        <i class="icon icon-clock-outline"></i>
        <span>This is a scheduled order for {{ selectedScheduleDescription }}</span>
      </div>
    }

    @if (showClosingSoonWarning()) {
      <div class="restaurant__closing-warning">
        <i class="icon icon-clock-outline"></i>
        <span>Closing soon. {{ minutesUntilClosing() }} minutes left to order.</span>
      </div>
    }

    <div class="content__filters filters">
      <div class="filters__list">
        <app-filter-list
          defaultValue=""
          [canDeselect]="false"
          [isLoading]="isLoadingCategories()"
          [filters]="sortedAllCategories()"
          (ngModelChange)="onCategoryChange($event)"
          [(ngModel)]="selectedCategory"
        />
      </div>
    </div>

    @if ((isLoadingProducts() || isMarketLoading()) && productsKeyValue.length === 0) {
      <div class="content__meals">
        <div class="content__meals_general">
          <app-skeleton-loader width="200px" height="32px" borderRadius="6px" />
          <div style="margin-top: 8px;">
            <app-skeleton-loader width="300px" height="20px" borderRadius="6px" />
          </div>
        </div>
        <ul class="content__meals_list">
          @for (item of [1, 2, 3, 4, 5, 6]; track item) {
            <li class="content__meals_list_item meal">
              <app-meal-card-skeleton />
            </li>
          }
        </ul>
      </div>
    } @else if (sortedAllCategories().length === 0 && !isLoadingCategories()) {
      <div class="content__empty">
        <h2>No categories available at the moment</h2>
        <p>Please try again later.</p>
      </div>
    } @else {
      @for (groupedProduct of productsKeyValue; track $index) {
        @let category = categories()[$any(groupedProduct.key)];
        @let products = groupedProduct.value;

        <div
          #categorySection
          class="content__meals"
          [class.content__meals--unavailable]="category && isCategoryUnavailable(category.id)"
          [attr.data-category]="category?.id"
        >
          <div class="content__meals_general">
            <h2 class="content__meals_title" [innerHTML]="category?.name"></h2>
            @if (getCategoryAvailabilityLabel(category)) {
              <p class="content__meals_subtitle availability-label">
                {{ getCategoryAvailabilityLabel(category) }}
              </p>
            }
            @if (category?.description) {
              <p class="content__meals_subtitle">
                {{ category?.description }}
              </p>
            }
          </div>
          <ul class="content__meals_list">
            @for (product of products; track product.id) {
              <li class="content__meals_list_item meal">
                <app-meal-card
                  [meal]="product"
                  (onAddToCart)="openMealSelectionModal(product)"
                />
              </li>
            }
          </ul>
        </div>
      } @empty {
        <div class="content__empty">
          <h2>No meals found</h2>
        </div>
      }
    }
  </div>
</div>
